/**
 * Storage configuration for development vs production
 *
 * In development: Use JSON files for easy syncing between machines
 * In production: Use database for multi-user support
 */

export const storageConfig = {
  // Set to 'json' for development, 'database' for production
  strategies: process.env.STRATEGY_STORAGE || "json",

  // API endpoints based on storage type
  getStrategyEndpoint: () => {
    return storageConfig.strategies === "json"
      ? "/api/strategies/json"
      : "/api/strategies";
  },

  // Validation endpoint based on storage type
  getValidationEndpoint: (strategyId: string) => {
    return storageConfig.strategies === "json"
      ? `/api/strategies/json/${strategyId}/validate`
      : `/api/strategies/${strategyId}/validate`;
  },
};
